import PropTypes from 'prop-types';
import React from 'react';

import { Drawer } from 'components/Drawer';
import LoadingState from 'components/LoadingState';
import { navigateToUrl } from 'utils/Url';

import CartGiftMessagingDrawerPanel from './CartGiftMessagingDrawerPanel';
import CartOverviewDrawerPanel from './CartOverviewDrawerPanel';

const Cart = ({
  addReturnsInsurance,
  hasFreeShipping,
  hasFreeShippingIndicator,
  subtotalWithCurrency,
  itemIds,
  itemCount,
  close,
  showUpsell,
  navigate,
  isLoading,
  newItemsBeingAdded,
  isEmpty,
  isOpen,
  errorMessage,
  message,
  giftMessage,
  viewGiftMessage,
  viewOverview,
  isGiftMessagingOn,
  isViewingOverview,
  isViewingGiftMessage,
  useLogoFreePackaging,
  isLogoFreePackagingAvailable,
  isSettingGiftingOptions,
  setGiftingOptions,
  checkoutUrl,
  isPriceChangeMessagingEnabled,
  showShoprunner,
  onCheckoutButtonClick,
  acceleratedPaymentMethodsData,
  trackAcceleratedPaymentMethodClick,
  isReturnInsuranceCampaignLoading,
  removeReturnsInsurance,
  returnsInsuranceCampaignVariant,
}) => (
  <div id="cart" className="Cart" tabIndex="-1">
    <Drawer visible={isOpen} close={close}>
      {isLoading && <LoadingState />}
      <CartOverviewDrawerPanel
        addReturnsInsurance={addReturnsInsurance}
        removeReturnsInsurance={removeReturnsInsurance}
        visible={isViewingOverview}
        close={close}
        itemCount={itemCount}
        hasFreeShippingIndicator={hasFreeShippingIndicator}
        isEmpty={isEmpty}
        navigate={navigate}
        errorMessage={errorMessage}
        message={message}
        newItemsBeingAdded={newItemsBeingAdded}
        itemIds={itemIds}
        isGiftMessagingOn={isGiftMessagingOn}
        giftMessage={giftMessage}
        useLogoFreePackaging={useLogoFreePackaging}
        viewGiftMessage={viewGiftMessage}
        subtotalWithCurrency={subtotalWithCurrency}
        hasFreeShipping={hasFreeShipping}
        showUpsell={showUpsell}
        isSettingGiftingOptions={isSettingGiftingOptions}
        isLogoFreePackagingAvailable={isLogoFreePackagingAvailable}
        checkoutUrl={checkoutUrl}
        isPriceChangeMessagingEnabled={isPriceChangeMessagingEnabled}
        showShoprunner={showShoprunner}
        onCheckoutButtonClick={onCheckoutButtonClick}
        acceleratedPaymentMethodsData={acceleratedPaymentMethodsData}
        trackAcceleratedPaymentMethodClick={trackAcceleratedPaymentMethodClick}
        returnsInsuranceCampaignVariant={returnsInsuranceCampaignVariant}
        isReturnInsuranceCampaignLoading={isReturnInsuranceCampaignLoading}
      />

      <CartGiftMessagingDrawerPanel
        visible={isViewingGiftMessage}
        viewOverview={viewOverview}
        giftMessage={giftMessage}
        useLogoFreePackaging={useLogoFreePackaging}
        isLogoFreePackagingAvailable={isLogoFreePackagingAvailable}
        setGiftingOptions={setGiftingOptions}
        isGiftMessagingOn={isGiftMessagingOn}
      />
    </Drawer>
  </div>
);

Cart.propTypes = {
  addReturnsInsurance: PropTypes.func,
  removeReturnsInsurance: PropTypes.func,
  hasFreeShipping: PropTypes.bool,
  hasFreeShippingIndicator: PropTypes.bool,
  subtotalWithCurrency: PropTypes.string,
  itemIds: PropTypes.arrayOf(PropTypes.string),
  itemCount: PropTypes.number,
  close: PropTypes.func.isRequired,
  showUpsell: PropTypes.bool,
  navigate: PropTypes.func,
  isLoading: PropTypes.bool,
  isEmpty: PropTypes.bool,
  isOpen: PropTypes.bool,
  newItemsBeingAdded: PropTypes.arrayOf(PropTypes.string),
  errorMessage: PropTypes.string,
  message: PropTypes.string,
  giftMessage: PropTypes.string,
  viewGiftMessage: PropTypes.func,
  viewOverview: PropTypes.func,
  isGiftMessagingOn: PropTypes.bool,
  isViewingOverview: PropTypes.bool,
  isViewingGiftMessage: PropTypes.bool,
  useLogoFreePackaging: PropTypes.bool,
  isLogoFreePackagingAvailable: PropTypes.bool,
  isSettingGiftingOptions: PropTypes.bool,
  setGiftingOptions: PropTypes.func,
  checkoutUrl: PropTypes.string,
  isPriceChangeMessagingEnabled: PropTypes.bool,
  showShoprunner: PropTypes.bool,
  onCheckoutButtonClick: PropTypes.func,
  acceleratedPaymentMethodsData: PropTypes.shape({
    supportedDigitalWallets: PropTypes.arrayOf(PropTypes.string),
  }),
  trackAcceleratedPaymentMethodClick: PropTypes.func,
  returnsInsuranceCampaignVariant: PropTypes.string,
  isReturnInsuranceCampaignLoading: PropTypes.bool,
};

Cart.defaultProps = {
  hasFreeShipping: false,
  hasFreeShippingIndicator: false,
  itemCount: 0,
  itemIds: [],
  showUpsell: false,
  navigate: navigateToUrl,
  isLoading: false,
  isEmpty: false,
  isOpen: false,
  newItemsBeingAdded: [],
  errorMessage: null,
  message: null,
  giftMessage: '',
  viewGiftMessage: () => {},
  viewOverview: () => {},
  isGiftMessagingOn: false,
  isViewingOverview: true,
  isViewingGiftMessage: false,
  setGiftingOptions: () => {},
  useLogoFreePackaging: false,
  isLogoFreePackagingAvailable: false,
  isSettingGiftingOptions: false,
  isPriceChangeMessagingEnabled: false,
  showShoprunner: false,
  onCheckoutButtonClick: () => {},
  acceleratedPaymentMethodsData: {},
  trackAcceleratedPaymentMethodClick: () => {},
  checkoutUrl: '/checkout',
  subtotalWithCurrency: null,
};

export default Cart;
